import { AccredibleButtonLoadingComponentModule } from '@accredible-frontend-v2/components/button-loading';
import { AccredibleDividerModule } from '@accredible-frontend-v2/components/divider';
import { TopBorderCardComponent } from '@accredible-frontend-v2/new-components/top-border-card';
import { TwoColumnsLayoutComponent } from '@accredible-frontend-v2/new-components/two-columns-layout';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { EmailSentRouterLinkAction } from '../email-sent/email-sent.component';
import { EmailSentComponentModule } from '../email-sent/email-sent.component.module';

const MATERIAL_MODULES = [MatButtonModule];

@Component({
  templateUrl: './email-verification.container.html',
  styleUrls: [`./email-verification.container.scss`],
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    EmailSentComponentModule,
    AccredibleDividerModule,
    AccredibleButtonLoadingComponentModule,
    RouterModule,
    ...MATERIAL_MODULES,
    TwoColumnsLayoutComponent,
    TopBorderCardComponent,
  ],
})
export class EmailVerificationContainer implements OnInit {
  private readonly _language = inject(AccredibleLanguageService);
  private readonly _title = inject(Title);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _userApi = inject(AccredibleUserApiService);

  status: 'succeeded' | 'failed';
  isUserSignedIn = false;
  routerLinkAction: EmailSentRouterLinkAction;

  private readonly _translationKey = 'email-verification';

  constructor() {
    this._title.setTitle('Accredible • Accounts • Email Verification');
  }

  ngOnInit(): void {
    this.status = this._route.snapshot.queryParams.status;
    this.isUserSignedIn = this._userApi.isUserSignedIn();

    if (this.status === 'succeeded') {
      this.routerLinkAction = {
        text: this._language.selectTranslate(
          this.isUserSignedIn
            ? `${this._translationKey}.continue`
            : `${this._translationKey}.sign_in`,
        ),
        routerLink: '/',
      };
    } else {
      this.routerLinkAction = {
        text: this._language.selectTranslate(`${this._translationKey}.forgot_password`),
        routerLink: '/forgot-password',
      };
    }
  }

  onActionButtonClicked(): void {
    this._router.navigate([this.routerLinkAction.routerLink]);
  }
}
